module.exports = __webpack_public_path__ + "media/images/captive_portal/router1-316ced8607974df2082f83e3396c2059.png";